module.exports = __webpack_public_path__ + "static/media/IMG_1562.f4adcb1e.JPG";